import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {Button, NavLink} from 'reactstrap';
import withTracker from '../containers/Full/withTracker';
import { connect } from 'react-redux';

import '../styles/sideProfile.scss';

import personIcon from '../img/person.png';
import axios from "axios";

class SideProfile extends Component {

    constructor(props) {
        super(props);
        this.state={};
        this.showUserInfo = this.showUserInfo.bind(this);
        this.getDetail = this.getDetail.bind(this);
        // this.getType = this.getType.bind(this);

    }
    componentDidMount() {
        this.showUserInfo();
        // this.getType();
        // console.log("this.state",this.state);
    }

    showUserInfo(){
        let that = this; //this는 dashboardBuyer component!
        console.log("side this state", this.state);
        axios.get('https://spice-api.pearlfall.vercel.app'+`/users/getUser`, this.state)
            .then(function (response) {
                console.log('show user info',response);
                that.setState({ //this.setState 하면 undefined나오는데, 이유는 then안에서 불리는 this는 dashboardBuyer component를 가리키지 않음
                    //따라서 that에 this를 저장해서 여기서 불러야함
                    username: response.data.username,
                    type: response.data.type,
                }, ()=>{
                    that.getDetail();
                });
                console.log("name", that.state.username);
            })
            .catch(function (error) {
                console.log(error);
            })
    }

    getDetail(){
        let that = this; //this는 dashboardBuyer component!
        // console.log(this); // not undefined
        // console.log("this.props", this.props);
        // console.log("this.state.username", this.state.username);
        let payload = {
            "username": this.state.username,
        }
        axios.post(this.state.type === 'Buyer' ?
            'https://spice-api.pearlfall.vercel.app'+`/users/profile/buyer`
            : 'https://spice-api.pearlfall.vercel.app'+`/users/profile/seller`, payload)
            .then(function (response) {
                // console.log(this, that); //after function, it's undefined
                // console.log('side profile response profile detail', response);
                that.setState({ //this.setState 하면 undefined나오는데, 이유는 then안에서 불리는 this는 dashboardBuyer component를 가리키지 않음
                    //따라서 that에 this를 저장해서 여기서 불러야함
                    sellerId: response.data.user.sellerId,
                    username: response.data.user.username,
                    name: response.data.user.name,
                    region: response.data.user.region,
                    topic: response.data.user.topic,
                    description: response.data.user.description,
                    avgScore: response.data.user.avgScore,
                    totalDeals: response.data.user.totalDeals,
                    keywords: response.data.user.keywords,
                    comments: response.data.user.comments,
                    photoUrl: response.data.user.photoUrl,
                }, ()=>{
                    // call after sellerId set on state
                    // console.log("check comments", that.state.comments);
                });
            })
            .catch(function (error) {
                console.log(error);
            })
    }

    render() {
        console.log("this.state", this.state);
        if (this.props.isAuthenticated) {
            return (
                <div>
                    <div className="profile-left">
                        {/* Show navbar for search page */}
                        {/*<div>*/}

                        <div className="img-container">
                            <img src={!this.state.photoUrl ? personIcon : this.state.photoUrl} className="profile-left-img"/>
                        </div>
                        <div className="summary-container">
                            <p><span className="wave">👋</span>Hi, {this.props.user.username}!<span className="wave">👋</span></p>
                            <p>You have done <span style={{"font-weight":"bold"}}>{this.state.totalDeals ? this.state.totalDeals : 0}</span> deals so far.
                                People have scored you <span style={{"font-weight":"bold"}}>{this.state.avgScore ? Math.round(this.state.avgScore *10)/10 : 0}</span> out of 5.
                                Don't forget to check out new people around <span style={{"font-weight":"bold"}}>{this.state.region}</span>
                            </p>
                            <Link className="btn-back link-profile" to = {'/dashboard/profile/' + this.state.username}>Go to Your Profile </Link>
                            {/*<a href={"localhost:3001/dashboard/profile" + this.state.username}>Go to your profile</a>*/}
                            {/*<NavLink href ='/dashboard/buyer'>Back to List </NavLink>*/}
                            {/*</Button>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                    {/*<Link className="btn-back" to = {'/dashboard/profile/' + this.state.username}>Go to Your Profile</Link>*/}

                </div>


            );
        } else
        {
            return (<div></div>);
        }
    }
}

function mapStateToProps(store) {
    // console.log("--->", store);
    return {
        user: store.auth.user,
        isAuthenticated: store.auth.isAuthenticated
    };
}

export default withRouter(connect(mapStateToProps)(SideProfile));
